export default "__VITE_ASSET__6180d8da__"